
import { updateBolStatusToDB } from "../../../graphql/updateBolStatus.mutation";
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../../context';
import actionTypeConstants from "../../../utils/actionTypeConstants"
function Common() {

  const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
  // CALL SAVE API

  const updateBolStatus = async (customerId: any, dailysheetId: any, status: any) => {
    let params = {
      "customerId": customerId,
      "dailysheetId": dailysheetId,
      "status": status

    }
    updateBolStatusToDB(params).then((dataResults: any) => {
      console.log("RESULT", dataResults)
      if (dataResults) {
        dispatch({
          'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
          'payload': {
            status,
            dataResults
          }
        })
      }
    })
      .catch((error: any) => {
        console.log("Update Bol Status(updateBolStatusToDB) Error:", error)
      })
  }

  return [updateBolStatus]
}



export default function useCommon() {
  const [updateBolStatus] = Common();
  return { updateBolStatus }
}